import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-749a6336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fields" }
const _hoisted_2 = { class: "c-field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "プロフィール画像", -1))
const _hoisted_4 = { class: "c-field__body" }
const _hoisted_5 = { class: "c-field__file" }
const _hoisted_6 = { class: "upload-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upload-cap" }, [
  /*#__PURE__*/_createTextVNode("※JPEG/GIF/PNG/BMP形式が使用可能です。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※著作権等の侵害にあたらない画像を使用してください。")
], -1))
const _hoisted_9 = { class: "c-field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "nickname"
}, "ニックネーム", -1))
const _hoisted_11 = { class: "c-field__body" }
const _hoisted_12 = { class: "c-field__input" }
const _hoisted_13 = { class: "c-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "性別", -1))
const _hoisted_15 = { class: "c-field__body" }
const _hoisted_16 = { class: "c-field__radio" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_female" }, "女性", -1))
const _hoisted_18 = { class: "c-field__radio" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_male" }, "男性", -1))
const _hoisted_20 = { class: "c-field__radio" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_other" }, "その他", -1))
const _hoisted_22 = { class: "c-field__radio" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_noanswer" }, "回答しない", -1))
const _hoisted_24 = { class: "c-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "誕生日", -1))
const _hoisted_26 = { class: "c-field__body" }
const _hoisted_27 = { class: "c-field__select" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: NaN }, "-", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "c-field__select" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: NaN }, "-", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "c-field__select" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: NaN }, "-", -1))
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "c-field" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "rimacomiId"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("リマコミ＋ID"),
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
  ])
], -1))
const _hoisted_38 = { class: "c-field__body" }
const _hoisted_39 = { class: "c-field__input" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rimacomi-tooltip" }, [
  /*#__PURE__*/_createTextVNode(" リマコミ＋IDとは "),
  /*#__PURE__*/_createElementVNode("span", { class: "rimacomi-tooltip-text" }, [
    /*#__PURE__*/_createTextVNode(" リマコミ＋上での固有のIDです。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" リマコミ＋IDを設定いただくことで、"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" お気に入り作品などをチェックできるあなた専用の本棚ページが作られ、"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" リマコミ＋を便利に楽しくお使いいただけます。 ")
  ])
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ha-signup-profile__note" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ha-signup-profile__discription" }, "上記のプライバシーガイドライン・各規約に同意のうえ")
], -1))
const _hoisted_42 = {
  class: "c-field has-submit",
  style: {"margin-top":"10rem"}
}
const _hoisted_43 = ["disabled"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入力内容を確認する", -1))
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_LinkageTerms = _resolveComponent("LinkageTerms")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "validation-schema": _ctx.schema,
    ref: "formRef"
  }, {
    default: _withCtx(({ errors, meta }) => [
      _createElementVNode("fieldset", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "upload-btn",
                title: "Upload image",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.operationImage && _ctx.operationImage(...args)))
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("img", {
                    src: (_ctx.image.path) ? _ctx.image.path : require('@/assets/images/common/img_user-default.svg'),
                    alt: "Upload image"
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["upload-icon", { 'is-delete':_ctx.isDeleteRef }])
                }, null, 2)
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(_ctx.imageErrorMsgRef), 513), [
          [_vShow, _ctx.imageErrorMsgRef]
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Field, {
                type: "text",
                id: "nickname",
                name: "nickname",
                modelValue: _ctx.userBase.commonAttrInfo.nickName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userBase.commonAttrInfo.nickName) = $event)),
                placeholder: "○○○○○○○○"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.nickname), 513), [
          [_vShow, errors.nickname]
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_female",
                name: "gender",
                value: "女性",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_male",
                name: "gender",
                value: "男性",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_other",
                name: "gender",
                value: "その他",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_noanswer",
                name: "gender",
                value: "無回答",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_23
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.gender), 513), [
          [_vShow, errors.gender]
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("select", {
                ref: "yearRef",
                name: "year",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.date.year) = $event)),
                onMouseup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.birthdayValidate()))
              }, [
                _hoisted_28,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: idx,
                    value: year
                  }, _toDisplayString(year), 9, _hoisted_29))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.date.year]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("select", {
                ref: "monthRef",
                name: "month",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.date.month) = $event)),
                onMouseup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.birthdayValidate()))
              }, [
                _hoisted_31,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: idx,
                    value: month
                  }, _toDisplayString(month), 9, _hoisted_32))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.date.month]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives(_createElementVNode("select", {
                ref: "dayRef",
                name: "day",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.date.day) = $event)),
                onMouseup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.birthdayValidate()))
              }, [
                _hoisted_34,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: idx,
                    value: date
                  }, _toDisplayString(date), 9, _hoisted_35))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.date.day]
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Field, {
                type: "text",
                name: "birthday",
                modelValue: _ctx.birthday,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.birthday) = $event)),
                style: {"display":"none"}
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.birthday), 513), [
          [_vShow, errors.birthday]
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_Field, {
                type: "text",
                id: "rimacomiId",
                name: "rimacomiId",
                placeholder: "半角英数字、アンダースコアを含む最大32文字まで",
                modelValue: _ctx.userRimacomi.rimacomiId,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userRimacomi.rimacomiId) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_40,
            _withDirectives(_createElementVNode("span", {
              class: "c-error",
              style: {"flex":"1 0 100%"}
            }, _toDisplayString(errors.rimacomiId), 513), [
              [_vShow, errors.rimacomiId]
            ])
          ])
        ]),
        (_ctx.firstServiceReg)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_LinkageTerms, { "initials-calss": 'ha-signup-profile' }),
              _hoisted_41
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("button", {
            class: "ha-btn is-submit",
            type: "button",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.moveConfirm && _ctx.moveConfirm(...args))),
            disabled: !meta.valid
          }, _hoisted_45, 8, _hoisted_43)
        ])
      ]),
      _createElementVNode("input", {
        ref: "fileUploadRef",
        type: "file",
        onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setImage($event))),
        accept: "image/*",
        style: {"visibility":"hidden","position":"absolute","top":"-200px"}
      }, null, 544)
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}